import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL, UPLOAD_URL } from '../config/config';

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${BASE_URL}/products`);
      const json = await res.json();
      if (res.ok && json.status === 200 && Array.isArray(json.data)) {
        const formatted = json.data.map((item) => ({
          id: Number(item.id),
          name: item.name,
          price: item.amount ? `${item.amount}` : 'N/A',
          offer_price: item.offer_price || '0',
          priceValue: item.amount
            ? Number(item.amount.toString().replace(/,/g, ''))
            : 0,
          status: item.status || 'Ready To Ship',
          category: item.category_name || 'Uncategorized',
          color: item.colors || 'N/A',
          fabric: item.fabrics || 'N/A',
          image: item.images
            ? `${UPLOAD_URL}/products/${item.images.split(',')[0]}`
            : 'https://via.placeholder.com/300x400?text=No+Image',
          createdAt: item.create_audit_time,
          raw: item,
        }));
        setProducts(formatted);
      } else {
        setProducts([]);
        setError(json.message || 'Failed to fetch products');
      }
    } catch (err) {
      console.error('Failed to fetch products:', err);
      setProducts([]);
      setError(err.message || 'Error fetching products');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <ProductContext.Provider value={{ products, loading, error, refetch: fetchProducts }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProducts = () => useContext(ProductContext);
